export const getFilterStyle = () => ({
  popoverContainer: {
    position: 'relative',
  },
});

export const getSearchFieldStyle = () => ({
  container: {
    paddingTop: 22,
    display: 'flex',
    paddingBottom: 15,
  },
});

export const getRootStyles = () => ({
  investImageRoot: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});
